import { render, staticRenderFns } from "./TexturedShapePropertyEditor.vue?vue&type=template&id=69729e4b&scoped=true&"
import script from "./TexturedShapePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./TexturedShapePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69729e4b",
  null
  
)

export default component.exports